// extracted by mini-css-extract-plugin
export default {"container":"G_1_xF","row":"D5gcWt","column":"VtGtBT","iconColumn":"qkVR4U"};